import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

export interface PopUpEntity {
  lnTitle?: string;
  lnContent?: string;
  lnOkText: string;
  lnCancelText: string;
}

@Injectable({
  providedIn: 'root'
})
export class PopUpNotificationService {

  constructor(private translate: TranslateService) {
    const element = document.createElement('div');
    element.setAttribute('id', 'notification-container');
    document.body.appendChild(element);
  }

  public confirmPopup(values: PopUpEntity): Promise<any> {
    const element = `
      <div id="parent-confirm" class="kl-confirm">
        <div class="kl-wrapper-box"></div>
        <div class="kl-confirm-box">
          <div class="kl-confirm-content">
            <div class="kl-confirm-header">
              <h4 class="regular">${values?.lnTitle}</h4>
              <h5 class="mt-2 light">${values?.lnContent}</h5>
            </div>
            <div class="btn-group mt-20">
              <button class="kl-btn btn-secondary p-2" id="onclickok"><span>${values?.lnOkText}</span></button>
              <button class="kl-btn btn-outline-primary ml-3 p-2" id="onclickcancel"><span>${values?.lnCancelText}</span></button>
            </div>
          </div>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', element);
    return this.resolver({success: 'onclickok', cancel: 'onclickcancel'});
  }

  private resolver(element: {success: string; cancel: string}): Promise<any> {
    const promise = new Promise((resolve, reject) => {
      this.handelActions(element.success, resolve);
      this.handelActions(element.cancel, reject);
    });
    return promise;
  }

  private handelActions(element, action) {
    document.getElementById(element).addEventListener('click', () => {
      action();
      const IdElement = document.getElementById('parent-confirm');
      IdElement.parentNode.removeChild(IdElement);
    });
  }

  private createNotification(message, status) {
    const idNotification = `notification-${Math.floor((Math.random() * 1000) + 1)}`;
    const parentElement = document.getElementById('notification-container');
    let icon = null;

    switch (status) {
      case 'info': {
        icon = 'bi bi-info-circle-fill info';
        break;
      }
      case 'error': {
        icon = 'bi bi-exclamation-diamond-fill error';
        break;
      }
      case 'success': {
        icon = 'bi bi-check-circle-fill success';
        break;
      }
      default: {
        icon = 'iconf-gaming3x error';
        break;
      }
    }
    const element = `
      <div id="${idNotification}" class="kl-notification mt-10">
        <i  class="${icon}"></i>
        <span class="light">${message}</span>
      </div>
    `;

    parentElement.insertAdjacentHTML('afterbegin', element);

    setTimeout(() => {
      const IdElement = document.getElementById(idNotification);
      IdElement.parentNode.removeChild(IdElement);
    }, 5000);
  }

  public error(message: string, field: string = null, translate: boolean = true) {
    let result_message = message;
    if(translate){
      const CODE = field ? `${message}_${field}` : message;
      result_message = message ? this.translate.instant(`ERRORS.${CODE}`): null;
    }
    this.createNotification(result_message || 'Hubo un error, intente más tarde.', 'error');
  }

  public info(message: string) {
    this.createNotification(message, 'info');
  }

  public success(message: string) {
    this.createNotification(message, 'success');
  }

}
